export const DEFAULT_VALUES = {
  email: '',
  name: '',
  document: '',
  homePhone: ''
}
